// Lazy loader for the Pusher waiter behavior.
//
// pusher_waiter pulls in pusher-js + simplero_pusher (~73KB), but it's only used on pages that have a
// `[data-behavior~=wait]` element (signup/billing/processing pages waiting on an async result). Most
// public pages (marketing, membership, landing) have none, so importing it eagerly is dead weight.
//
// Instead we register a tiny onDomChanged hook: the first time a wait element appears, we dynamically
// import the real module (which calls registerManager) and re-fire `.changed()` on the element so the
// freshly-registered manager sets itself up. A data flag makes this one-shot per element to avoid
// re-triggering our own hook in a loop. Further wait elements are handled by pusher_waiter directly.

let loadPromise = null

if (window.onDomChanged) {
  window.onDomChanged('[data-behavior~=wait]', function () {
    const $elm = this
    if ($elm.data('pusherWaiterLazyLoaded')) return
    $elm.data('pusherWaiterLazyLoaded', true)

    loadPromise ||= import('./pusher_waiter')
    loadPromise.then(() => $elm.changed())
  })
}
